import {ThemeColors} from '../themeColors';

export const useSpotColors = () => ThemeColors.spot;
